import * as R from 'remeda'

/**
 * 配列内に値が存在する場合はその値を削除し、存在しない場合は追加します。
 *
 * @template T - 配列内の値の型。
 * @param items - 配列。
 * @param item - 追加または削除する値。
 * @returns 値を追加または削除した配列。
 */
export function toggleItem<T>(items: T[], item: T): T[]

/**
 * 配列内に値が存在する場合はその値を削除し、存在しない場合は追加します。
 *
 * @template T - 配列内の値の型。
 * @param item - 追加または削除する値。
 * @returns 配列を引数に取り、値を追加または削除した配列を返す関数。
 */
export function toggleItem<T>(item: T): (items: T[]) => T[]

/**
 * @param args - 引数。
 * @returns 結果または部分適用された関数。
 */
export function toggleItem<T>(
  ...args: [T[], T] | [T]
): T[] | ((items: T[]) => T[]) {
  const toggleItemInner = (items: T[], item: T): T[] =>
    items.includes(item)
      ? items.filter(R.isNot(R.isDeepEqual(item)))
      : [...items, item]

  if (args.length === 1) {
    return (items: T[]) => toggleItemInner(items, ...args)
  }

  return toggleItemInner(...args)
}
